module.exports = __webpack_public_path__ + "img/xin.0e597f3a.png";